/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-restricted-globals */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { getGuide, showModal } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import GuidebarModalBody, {
  GuidebarModalTitle,
} from "components/header/GuidebarModal";
import Helpers from "util/helpers";
import i18n from "i18next";

class Guidebar extends Component {
  state = {
    guideListFetched: false,
    searchTerm: "",
  };

  unlisten = this.props.history.listen((location, action) => {
    // if (location.pathname.toLowerCase() !== "/login") {
    //   // this.fetchGuide();
    // }
  });

  componentDidMount() {
    setTimeout(() => {
      if (
        localStorage.getItem("token") &&
        location.pathname.toLowerCase() !== "/login" &&
        location.pathname.toLowerCase() !== "/logout"
      ) {
        this.fetchGuide();
      }
    }, 500);
  }

  fetchGuide = () => {
    this.props.getGuide(5000, this.onBegin, this.onSuccess, this.onError);
    this.unlisten();
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
    this.setState({
      guideListFetched: true,
    });
  };

  guideTypeHandler = (event) => {
    if (!this.state.guideListFetched) this.fetchGuide();

    this.setState({
      searchTerm: event.target.value,
    });
  };

  // renderers

  renderResults = () => {
    if (this.state.searchTerm.length < 2) return null;
    let fixedSearchTerm = Helpers.getTurkishCharaterFixedList(
      this.state.searchTerm,
      []
    );
    const results = this.props.guide.data
      .filter((contact) => {
        if (!contact.fullname) return false;
        let fixedName = Helpers.getTurkishCharaterFixedList(contact.fullname);
        let splittedName = fixedName.split(" ");

        for (let i = 0; i < splittedName.length; i++) {
          if (!fixedSearchTerm.includes(" ")) {
            if (splittedName[i].startsWith(fixedSearchTerm)) return true;
          } else {
            // search in all name combinations
            let nameCombinations = Helpers.combine(splittedName, 1);
            for (let i = 0; i < nameCombinations.length; i++) {
              if (nameCombinations[i].join(" ").startsWith(fixedSearchTerm))
                return true;
            }
          }
        }
        return false;
      })
      .map((filteredContact) => {
        return (
          <tr
            key={filteredContact.id}
            onClick={() => this.showContactDetail(filteredContact)}
          >
            <td>{filteredContact.fullname}</td>
            <td>{`${filteredContact.department} / ${filteredContact.position}`}</td>
          </tr>
        );
      });

    return results;
  };

  renderTable = () => {
    if (this.state.guideListFetched && this.state.searchTerm) {
      return (
        <>
          <table
            className="table table-bordered guideSearchResult"
            id="guideSearchResult"
            style={{ display: "table", overflowY: "hidden" }}
          >
            <tbody
              style={{
                display: "inline-block",
                overflowY: "scroll",
                maxHeight: "500px",
              }}
            >
              {this.renderResults()}
            </tbody>
          </table>
          <Link
            to="/guide"
            className="allnatification-link text-center"
            id="all-guide-btn"
            style={{ display: "block" }}
          >
            <div className="allguide-link-title">Tüm Rehberi Göster</div>
          </Link>
        </>
      );
    } else {
      return null;
    }
  };

  showContactDetail = (contact) => {
    this.props.showModal({
      modalType: "GuideDetail",
      modalTitle: <GuidebarModalTitle />,
      modalContent: <GuidebarModalBody id={contact.id} />,
      modalFooter: null,
      modalElementId: "guideModal",
    });
  };

  // TODO : Bu ne yapıyor?
  //   $("ul.notif li:first-child").hover(function() {
  //     $("#guideSearch")[0].value = "";
  //     $("#guideSearchResult").css("display", "none");
  //     $("#all-guide-btn").css("display", "none");
  //   });

  renderInitialState = () => {
    return (
      <>
        <div className="inner-addon left-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            onChange={(e) => this.guideTypeHandler(e)}
            type="text"
            name="guideSearch"
            id="guideSearch"
            className="form-control"
            placeholder={i18n.t("10176")} //"Rehberde Arama..."
            value={this.state.searchTerm}
          />
        </div>
        {this.renderTable()}
      </>
    );
  };

  render() {
    if (Object.keys(this.props.generalProfile).length === 0) return null;

    return (
      <>
        <a href="#">
          <span className="iconmford fo-icon-contacts"></span>
        </a>
        <div className="searchArea">{this.renderInitialState()}</div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
    guide: state.guide,
    modal: state.modal,
    application: state.application,
  };
};

export default connect(mapStateToProps, { getGuide, showModal })(
  withRouter(containsLongRunningProcess(Guidebar))
);
